{
  "vessel": {
    "u0": -17,
    "chordU": 17,
    "vc": 0,
    "half": 4.1,
    "eaveY": 10.2,
    "ridgeY": 16.4
  },
  "front": {
    "portalSill": 0,
    "portalTop": 2.8,
    "portalShare": 0.2,
    "windowSill": 3.8,
    "windowTop": 10.7,
    "windowShare": 0.5,
    "oculusHeight": 12.7,
    "oculusRadius": 0.48
  },
  "sides": {
    "bay": 6.8,
    "windowSill": 2.2,
    "windowTop": 8.7
  },
  "buttresses": {
    "centres": [-10.2, -3.4, 3.4, 10.2],
    "width": 0.55,
    "depth": 0.24,
    "height": 7.5
  },
  "note": "Separate, lower Pieters chapel beside Margriet on the east side of the Nes. The single long body and Gothic front are read from the painting and woodcut; the labelled 1760 view derives from 1544, and the 1611 print depicts later market use. All dimensions, elevation heights, roof covering, buttresses, openings, closed portal, exact street setback and hidden east termination are reconstruction estimates. Neither the later market furniture and laboratory nor the 1779 extension to the canal is backdated. The hospital ward compound remains separately recorded; its full historical parcel relationship is unresolved."
}
